import { FieldTypes } from '../types';
import {
  dateOperators,
  dateRangeOperators,
  globalOperators,
  stringOperators,
  textOperators,
} from '../types/operatorTypes';

const source = 'listItem';

export const getListItemFields = (): FieldTypes[] => [
  {
    label: 'Value',
    prop: 'value',
    operators: [...globalOperators, ...textOperators, ...stringOperators],
    type: 'text',
    source: source,
  },
  {
    label: 'Description',
    prop: 'description',
    operators: [...globalOperators, ...textOperators, ...stringOperators],
    type: 'text',
    source,
  },
  {
    label: 'Created',
    prop: 'created',
    operators: [
      ...globalOperators,
      ...dateRangeOperators.filter((d) => d.type !== 'next'),
      ...dateOperators,
    ],
    type: 'date',
    source,
    disableFuture: true,
  },
  {
    label: 'Expiration',
    prop: 'expirationDate',
    operators: [...globalOperators, ...dateRangeOperators, ...dateOperators],
    type: 'date',
    source,
    disableFuture: true,
  },
];
